import { Entity } from "../../common";
import { DataSourceRemoteType } from "./enums";
import { z } from "zod";
export const ImportJobState = z.enum([
    "PendingInput",
    "Queued",
    "InProgress",
    "Failed",
    "Success",
]);
export const ImportJobOperation = z.enum(["Check", "Import"]);
export const ImportJob = Entity.extend({
    designSystemId: z.string(),
    designSystemVersionId: z.string(),
    sourceIds: z.array(z.string()),
    state: ImportJobState,
    createdByUserId: z.string().optional(),
    importContextId: z.string(),
    error: z.string().optional(),
    sourceType: DataSourceRemoteType,
    importContextCleanedUp: z.boolean(),
});
